import * as attendeesFunc from '../services/attendees';
import dateTimeDecorator from '../services/dateTimeDecorator';
import * as courseList from '../actions/courseList';

function generateDefaultTestimonialForm(courseId) {

    return {
        id: 0,
        author_name: '',
        organisation_name: '',
        content: '',
        course_id: courseId
    };
}

var defaultState = {
    timetables: [],
    venues: [],
    presenters: [],
    resourcePacks: [],
    selectedCourseId: null,
    isCourseOverlayOpen: false,
    isELearningCourse: false,
    isDeleteCourseOverlayOpen: false,
    isDeleteTestimonialOverlayOpen: false,
    isTestimonialListOverlayOpen: false,
    isAddTestimonialOverlayOpen: false,
    isEditTestimonialOverlayOpen: false,
    isEditAttendeeOverlayOpen: false,
    courses: [],
    eLearningCourses: [],
    isRefreshingCourses: false,
    testimonials: [],
    modules: [],
    courseFormMode: 'add',
    testimonialFormMode: 'add',
    courseToEdit: null,
    testimonialToEdit: null,
    courseToDelete: null,
    testimonialToDelete: null,
    defaultTestimonialForm: generateDefaultTestimonialForm(),
    defaultCourseForm: {
        id: 0,
        name: '',
        description: '',
        module_id: 1,
        start_date: null,
        start_time: '00:00',
        end_date: null,
        end_time: '00:00',
        timetable_id: null,
        elearning_course_id: null,
        venue_id: 1,
        private_price: '0.00',
        public_price: '0.00',
        override_price: false,
        overridden_price: null,
        presenters: [],
        resource_packs: [],
        type: 'classroom',
        units: [],
        allow_multi_delegate_discount: true
    },
    attendeeSorts: {},
    attendeeOverlayShowing: false,
    attendeeModules: [],
    attendeeToEdit: null,
    isDeleteAttendeeOverlayOpen: false,
    attendeeToDelete: null
};



export default function(state = defaultState, action) {

    switch (action.type) {

        case courseList.COURSE_LIST_REFRESHING:

            return {
                ...state,
                isRefreshingCourses: action.isRefreshing
            };

        case courseList.COURSE_LIST_RESOURCE_PACKS_LOADED:

            return {
                ...state,
                resourcePacks: action.packs
            };

        case courseList.COURSE_LIST_PRESENTERS_LOADED:

            return {
                ...state,
                presenters: action.presenters
            };

        case courseList.COURSE_LIST_VENUES_LOADED:

            return {
                ...state,
                venues: action.venues
            };

        case courseList.COURSE_LIST_TIMETABLES_LOADED:

            return {
                ...state,
                timetables: action.timetables
            };

        case courseList.CANCEL_TESTIMONIAL_FORM_OVERLAY:

            return Object.assign({}, state, {
                isTestimonialListOverlayOpen: true,
                isAddTestimonialOverlayOpen: false,
                isEditTestimonialOverlayOpen: false
            });

        case courseList.SHOW_EDIT_TESTIMONIAL_FORM:

            return Object.assign({}, state, {
                isTestimonialListOverlayOpen: false,
                isEditTestimonialOverlayOpen: true,
                testimonialToEdit: action.testimonial,
                testimonialFormMode: 'edit'
            });

        case courseList.SHOW_DELETE_TESTIMONIAL_OVERLAY:

            return Object.assign({}, state, {
                isDeleteTestimonialOverlayOpen: true,
                testimonialToDelete: action.testimonial
            });

        case courseList.HIDE_DELETE_TESTIMONIAL_OVERLAY:

            return Object.assign({}, state, {
                isDeleteTestimonialOverlayOpen: false
            });

        case courseList.SHOW_TESTIMONIAL_LIST_OVERLAY:

            return Object.assign({}, state, {
                isTestimonialListOverlayOpen: true,
                selectedCourseId: action.courseId,
                defaultTestimonialForm: generateDefaultTestimonialForm(action.courseId)
            });

        case courseList.HIDE_TESTIMONIAL_LIST_OVERLAY:

            return Object.assign({}, state, {
                isTestimonialListOverlayOpen: false,
                selectedCourseId: null,
                testimonials: []
            });

        case courseList.SHOW_ADD_TESTIMONIAL_FORM:

            return Object.assign({}, state, {
                isTestimonialListOverlayOpen: false,
                isAddTestimonialOverlayOpen: true,
                testimonialFormMode: 'add'
            });

        case courseList.HIDE_TESTIMONIAL_FORM_OVERLAY:

            return Object.assign({}, state, {
                isTestimonialListOverlayOpen: true,
                isAddTestimonialOverlayOpen: false,
                isEditTestimonialOverlayOpen: false
            });

        case courseList.CLOSE_TESTIMONIAL_FORM_OVERLAY:

            return Object.assign({}, state, {
                isAddTestimonialOverlayOpen: false,
                isEditTestimonialOverlayOpen: false
            });

        case courseList.HIDE_DELETE_COURSE_OVERLAY:

            return Object.assign({}, state, {
                isDeleteCourseOverlayOpen: false,
                courseToDelete: null
            });

        case courseList.SHOW_DELETE_COURSE_OVERLAY:

            return Object.assign({}, state, {
                isDeleteCourseOverlayOpen: true,
                courseToDelete: action.course
            });

        case courseList.SHOW_EDIT_COURSE_OVERLAY:

            return Object.assign({}, state, {
                isCourseOverlayOpen: true,
                courseFormMode: 'edit',
                courseToEdit: dateTimeDecorator.decorateStartEndDateTime(action.course)
            });

        case courseList.SHOW_NEW_COURSE_OVERLAY:

            return Object.assign({}, state, {
                isCourseOverlayOpen: true,
                courseFormMode: 'add',
            });

        case courseList.SET_ELEARNING_COURSE:

            return Object.assign({}, state, {
                isELearningCourse: action.isELearningCourse
            });

        case courseList.HIDE_COURSE_OVERLAY:

            return Object.assign({}, state, {
                isCourseOverlayOpen: false,
                courseToEdit: null
            });

        case courseList.ADMIN_COURSE_LIST_REFRESHED:

            const attendeeSorts = action.courses.reduce((map, course) => {

                map[course.id] = {
                    organisation: null,
                    last_name: null
                };

                return map;

            }, {});

            return Object.assign({}, state, {
                attendeeSorts: attendeeSorts,
                courses: action.courses,
                eLearningCourses: action.eLearningCourses
            });

        case courseList.ADMIN_TESTIMONIAL_LIST_REFRESHED:

            return Object.assign({}, state, {
                testimonials: action.testimonials
            });

        case courseList.ADMIN_MODULE_LIST_REFRESHED:

            return Object.assign({}, state, {
                modules: action.modules
            });

        case courseList.SORT_ELEARNING_ATTENDEES: {

            const { courseId, attribute, direction } = action;

            return {
                ...state,
                attendeeSorts: attendeesFunc.getUpdatedAttendeeSorts(state.courses, courseId, attribute, direction),
                events: state.courses.map((course) => {

                    if (course.id === action.courseId) {

                        return {
                            ...course,
                            attendees: attendeesFunc.sortAttendees(course.attendees, attribute, direction)
                        }

                    } else {

                        return course;
                    }
                })
            };
        }

        case courseList.TOGGLE_SELECT_ALL_ELEARNING_ATTENDEES: {

            return {
                ...state,
                courses: attendeesFunc.toggleSelectAllAttendees(state.courses, action.courseId)
            };
        }

        case courseList.ELEARNING_ATTENDEE_SELECT_CHANGED: {

            return {
                ...state,
                courses: attendeesFunc.setSelectedAttendee(state.courses, action.courseId, action.attendeeId, action.isSelected)
            };
        }

        case courseList.TOGGLE_ATTENDEE_MODULE_OVERLAY:

            return {
                ...state,
                attendeeOverlayShowing: !state.attendeeOverlayShowing
            }

        case courseList.UPDATE_ATTENDEE_MODULES:

            return {
                ...state,
                attendeeModules: action.modules
            }

        case courseList.RESET_SELECT_ALL_ELEARNING_ATTENDEES: {

            return {
                ...state,
                courses: attendeesFunc.resetSelectAllAttendees(state.courses, action.courseId)
            };
        }

        case courseList.SHOW_EDIT_ELEARNING_ATTENDEE_OVERLAY:

            return {
                ...state,
                isEditAttendeeOverlayOpen: true,
                attendeeToEdit: action.attendee
            };

        case courseList.HIDE_EDIT_ELEARNING_ATTENDEE_OVERLAY:

            return {
                ...state,
                isEditAttendeeOverlayOpen: false
            }

        case courseList.SHOW_DELETE_ELEARNING_ATTENDEE_OVERLAY: {

            return {
                ...state,
                isDeleteAttendeeOverlayOpen: true,
                attendeeToDelete: action.attendee
            };
        }

        case courseList.HIDE_DELETE_ELEARNING_ATTENDEE_OVERLAY:

            return {
                ...state,
                isDeleteAttendeeOverlayOpen: false
            }

        case courseList.SHOW_DELETE_ELEARNING_COURSE_OVERLAY:

            return {
                ...state,
                isDeleteCourseOverlayOpen: true,
                courseToDelete: action.course
            }

        case courseList.HIDE_DELETE_ELEARNING_COURSE_OVERLAY:

            return {
                ...state,
                isDeleteCourseOverlayOpen: false
            }

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/courseList.js